import { EntityState } from '@ngrx/entity';
import { Advantage, DigitalCourse, DigitalCourseFilter, Question } from '@modules/course/digitalcourse/models';

export const digitalCourseFeatureKey = 'digitalcourse';

export interface DigitalCourseState extends EntityState<DigitalCourse> {
  selectedDigitalCourseId: string;
  error: any;
  totalCount: number;
  filter: DigitalCourseFilter;
  advantages: Advantage[];
  questions: Question[];
}
